import React, { useState } from "react";
import styles from "./styles/OutputWindowAmount.module.css";
import { useTranslation } from "react-i18next";
import useNumberFormat from "../../../hooks/useNumberFormat";

/**
 * Amount window output component
 * Used in the ticket info section in the search page
 */
const OutputWindowAmount = ({ amount, penalty, total, currency, tax }) => {
    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);
    const formatNum = useNumberFormat();
    return (
        <div className={`${styles.main_output_menu_container}`}>
            <div className={`${styles.output_menu_container}`}>
                {/* ______________________________________________________ Amount */}
                <div className={`${styles.output_amount_label}`}>
                    {t(`amount`)}:
                </div>
                <div
                    className={`${styles.output_amount_value}`}
                >{`${currency}${formatNum(amount)}`}</div>
                {/* ______________________________________________________ Amount */}

                <div className={`${styles.output_sign} ${styles.sign1}`}>+</div>

                {/* ______________________________________________________ Tax */}
                <div className={`${styles.output_tax_label}`}>{t(`tax`)}:</div>
                <div
                    className={`${styles.output_tax_value}`}
                >{`${currency}${formatNum(tax)}`}</div>
                {/* ______________________________________________________ Tax */}

                <div className={`${styles.output_sign} ${styles.sign2}`}>+</div>
                {/* ______________________________________________________ Penalty */}

                <div className={`${styles.output_penalty_label}`}>
                    {t(`payments`)}/
                    <br />
                    {t(`charges`)}:
                </div>

                <div
                    className={`${styles.output_penalty_value}`}
                >{`${currency}${formatNum(penalty)}`}</div>
                {/* ______________________________________________________ Penalty */}

                <div className={`${styles.output_ruler_container}`}>
                    <hr className={`${styles.output_ruler}`} />
                </div>
                {/* ______________________________________________________ Total */}

                <div className={`${styles.output_total_label}`}>
                    {t(`total`)}:
                </div>
                <div
                    className={`${styles.output_total_value}`}
                >{`${currency}${formatNum(total)}`}</div>
                {/* ______________________________________________________ Total */}
            </div>
        </div>
    );
};

export default OutputWindowAmount;
